<ng-container *ngIf="inValid()">
    <em *ngFor="let error of getErrors()" class="error-text">
        {{error}}
    </em>
</ng-container>
<ng-container *ngIf="!inValid()">
    <span>&nbsp;</span>
</ng-container>
